import { render } from "./BaseTooltip.vue?vue&type=template&id=544842e3&scoped=true&ts=true"
import script from "./BaseTooltip.vue?vue&type=script&lang=ts"
export * from "./BaseTooltip.vue?vue&type=script&lang=ts"

import "./BaseTooltip.vue?vue&type=style&index=0&id=544842e3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-544842e3"]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip});
